/**
 * @generated SignedSource<<4578650f7a6fe4e1474f11e8181e051b>>
 * @relayHash 21354ce056af321d3c9a22d041061cbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 995f0038c2de9764a22d6b1084f25ff437d0af79bc8d777102ec6b571d9ec00a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type preloadOperationsQuery$variables = Record<PropertyKey, never>;
export type preloadOperationsQuery$data = {
  readonly siteOperations: {
    readonly application: ReadonlyArray<string | null | undefined>;
    readonly userProfile: ReadonlyArray<string | null | undefined>;
  } | null | undefined;
};
export type preloadOperationsQuery = {
  response: preloadOperationsQuery$data;
  variables: preloadOperationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "SiteOperations",
    "kind": "LinkedField",
    "name": "siteOperations",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "userProfile"
      },
      {
        "kind": "ScalarField",
        "name": "application"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "preloadOperationsQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "preloadOperationsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "21354ce056af321d3c9a22d041061cbd",
    "id": "995f0038c2de9764a22d6b1084f25ff437d0af79bc8d777102ec6b571d9ec00a",
    "metadata": {},
    "name": "preloadOperationsQuery",
    "operationKind": "query",
    "text": "query preloadOperationsQuery{siteOperations{userProfile,application}}"
  }
};
})();

(node as any).hash = "abad04e66f2fedacc515f8a26b1558e3";

export default node;
